import { MyUploadDetails } from '@/routes/_auth/_modules/_app/my-uploads/-components/MyUploadDetails'
import { UPLOAD_SCOPES, UploadScope } from '@repo/csv'
import { createFileRoute } from '@tanstack/react-router'

type RouteParams = {
  fileName: string
  scope: UploadScope
}

export const Route = createFileRoute('/_auth/_modules/crt/my-uploads/$scope/$fileName')({
  component: UploadReport,
  loader: async ({ params: { fileName, scope } }: { params: RouteParams }) => {
    return {
      crumb: fileName,
      scope,
    }
  },
  parseParams: (params) => {
    if (!UPLOAD_SCOPES.includes(params.scope as UploadScope)) {
      throw new Error('Invalid Upload Scope')
    }

    return {
      fileName: params.fileName,
      scope: params.scope as UploadScope,
    }
  },
})

function UploadReport() {
  const { fileName, scope } = Route.useParams()

  return <MyUploadDetails fileName={fileName} scope={scope} module="crt" maxWidth="wide" />
}
